export default __webpack_public_path__ + "static/polyient-b1419bb4ec8bd39dca5e497bb50a8649.jpg";